import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _f7ea2d8a = () => interopDefault(import('../../../pages/contattaci/index.vue' /* webpackChunkName: "pages/contattaci/index" */))
const _e6b2a81e = () => interopDefault(import('../../../pages/contattare-azienda/index.vue' /* webpackChunkName: "pages/contattare-azienda/index" */))
const _e65ee072 = () => interopDefault(import('../../../pages/contattaci/confermato.vue' /* webpackChunkName: "pages/contattaci/confermato" */))
const _205fe25e = () => interopDefault(import('../../../pages/contattare-azienda/confermato.vue' /* webpackChunkName: "pages/contattare-azienda/confermato" */))
const _177c040e = () => interopDefault(import('../../../pages/richieste-di-preventivi/comincia.vue' /* webpackChunkName: "pages/richieste-di-preventivi/comincia" */))
const _ec12fc64 = () => interopDefault(import('../../../pages/richieste-di-preventivi/controlla-il-tuo-telefono.vue' /* webpackChunkName: "pages/richieste-di-preventivi/controlla-il-tuo-telefono" */))
const _cd47a8e8 = () => interopDefault(import('../../../pages/richieste-di-preventivi/i-tuoi-dati.vue' /* webpackChunkName: "pages/richieste-di-preventivi/i-tuoi-dati" */))
const _11c40f5f = () => interopDefault(import('../../../pages/richieste-di-preventivi/preventivo-completato.vue' /* webpackChunkName: "pages/richieste-di-preventivi/preventivo-completato" */))
const _35842b57 = () => interopDefault(import('../../../pages/richieste-di-preventivi/tipo-di-progetto.vue' /* webpackChunkName: "pages/richieste-di-preventivi/tipo-di-progetto" */))
const _3486ab5e = () => interopDefault(import('../../../pages/richieste-di-preventivi/tipo-tetto-stima-consumo-elettrico-annuale.vue' /* webpackChunkName: "pages/richieste-di-preventivi/tipo-tetto-stima-consumo-elettrico-annuale" */))
const _67770342 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const _861e7d2c = () => interopDefault(import('../../../../../shared/all/page/privacy/PrivacyPage.vue' /* webpackChunkName: "" */))
const _1b702a1e = () => interopDefault(import('../../../../../shared/all/page/termsAndConditions/TermsAndConditionsPage.it.vue' /* webpackChunkName: "" */))
const _1c6fcb10 = () => interopDefault(import('../../../../../shared/all/page/cookies/CookiesPage.vue' /* webpackChunkName: "" */))
const _2b1ecb13 = () => interopDefault(import('../../../../../shared/all/themes/blueflow/page/ErrorPage.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contattaci",
    component: _f7ea2d8a,
    name: "contattaci"
  }, {
    path: "/contattare-azienda",
    component: _e6b2a81e,
    name: "contattare-azienda"
  }, {
    path: "/contattaci/confermato",
    component: _e65ee072,
    name: "contattaci-confermato"
  }, {
    path: "/contattare-azienda/confermato",
    component: _205fe25e,
    name: "contattare-azienda-confermato"
  }, {
    path: "/richieste-di-preventivi/comincia",
    component: _177c040e,
    name: "richieste-di-preventivi-comincia"
  }, {
    path: "/richieste-di-preventivi/controlla-il-tuo-telefono",
    component: _ec12fc64,
    name: "richieste-di-preventivi-controlla-il-tuo-telefono"
  }, {
    path: "/richieste-di-preventivi/i-tuoi-dati",
    component: _cd47a8e8,
    name: "richieste-di-preventivi-i-tuoi-dati"
  }, {
    path: "/richieste-di-preventivi/preventivo-completato",
    component: _11c40f5f,
    name: "richieste-di-preventivi-preventivo-completato"
  }, {
    path: "/richieste-di-preventivi/tipo-di-progetto",
    component: _35842b57,
    name: "richieste-di-preventivi-tipo-di-progetto"
  }, {
    path: "/richieste-di-preventivi/tipo-tetto-stima-consumo-elettrico-annuale",
    component: _3486ab5e,
    name: "richieste-di-preventivi-tipo-tetto-stima-consumo-elettrico-annuale"
  }, {
    path: "/",
    component: _67770342,
    name: "index"
  }, {
    path: "*",
    redirect: {"path":"/"}
  }, {
    path: "/politica-sulla-riservatezza",
    component: _861e7d2c,
    name: "politica-sulla-riservatezza"
  }, {
    path: "/termini-e-condizioni-generali",
    component: _1b702a1e,
    name: "termini-e-condizioni-generali"
  }, {
    path: "/cookie",
    component: _1c6fcb10,
    name: "cookie"
  }, {
    path: "/error",
    component: _2b1ecb13,
    name: "error"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
